module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/search-fed84ee3ce7b9a9aa02070f07cb00a3c.svg";